import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-lfsa-page-size-selector',
  templateUrl: './lfsa-page-size-selector.component.html',
  styleUrls: ['./lfsa-page-size-selector.component.css']
})
export class LfsaPageSizeSelectorComponent {

  @Input()
  pageSizeOptions: number[] = [10, 25, 50];

  @Input()
  pageSize = 10;

  @Output()
  onPageSizeChange = new EventEmitter<number>();

  pageSizeChanged() {
    this.onPageSizeChange.emit(this.pageSize);
  }

}
